import script from "./ArticlesSearchbarSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesSearchbarSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ArticlesSearchbarSkeleton.vue?vue&type=style&index=0&id=21c71770&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c71770"]])

export default __exports__